import AwardsList from './AwardsList';

export default AwardsList;
